<template>
  <div class="heads">
    <div class="heads-top">
		<div class="box">
			<img src="../assets/img/zp.png" alt="">
			<div class="zpbz">
				<div style="font-size:20px;color:#333333">正品保障</div>
				<div style="font-size:16px;color:#999999">购物无忧</div>
			</div>
		</div>
		<div class="box" >
			<img src="../assets/img/zp1.png" alt="">
			<div class="zpbz">
				<div style="font-size:20px;color:#333333">省钱兄科技</div>
				<div style="font-size:16px;color:#999999">为您精选优质品种</div>
			</div>
		</div>
		<div class="box">
			<img src="../assets/img/zp2.png" alt="">
			<div class="zpbz">
				<div style="font-size:20px;color:#333333">售后无忧</div>
				<div style="font-size:16px;color:#999999">服务至上</div>
			</div>
		</div>
		<div class="box">
			<img src="../assets/img/zp3.png" alt="">
			<div class="zpbz">
				<div style="font-size:20px;color:#333333">帮助中心</div>
				<div style="font-size:16px;color:#999999">全面购物指南</div>
			</div>
		</div>
	</div>
    <div class="big-center">
      <div class="center">
        <div class="cont left">
          <img class="logos" src="../assets/img/logo2.png" />
			<div class="weixin1"><span style="color:#999999">客服微信：</span><span style="color:#333333;font-size:26px">{{ weixin }}</span></div>
          <div class="weixin" style="color:#999999">联系地址：{{ address }}</div>
        </div>
        <div style="display:flex;margin-top:40px;box-sizing: border-box;margin-left:47px">
            <ul>
              <ol><a href="javascript:;" @click="goTo('/order')">个人中心</a></ol>
              <li><a href="javascript:;">门店信息</a></li>
              <li><a href="javascript:;">修改密码</a></li>
              <li><a href="javascript:;" @click="goTo('/order?select=address')">地址管理</a></li>
            </ul>
            <ul style="margin-left:98px">
              <ol><a href="javascript:;">入驻信息</a></ol>
              <li><a href="javascript:;">门店入驻</a></li>
              <li><a href="javascript:;">商家入驻</a></li>
              <li><a href="javascript:;" @click="goChat()">联系我们</a></li>
            </ul>
            <ul style="margin-left:98px">
              <ol><a href="javascript:;">下单交易</a></ol>
              <li><a href="javascript:;">下单问题</a></li>
              <li><a href="javascript:;">电脑单盖章</a></li>
              <li><a href="javascript:;">检验报告盖章</a></li>
            </ul>
        </div>
        <div class="cont right">
          <div class="xcx">
            <img class="erweima" :src="QRcode" />
            <div class="saoma">扫描二维码 <br />获取全网优质商品</div>
          </div>
          <div class="xcx">
            <img class="erweima" :src="downcode" />
            <div class="saoma">扫描二维码 <br />下载自营商城APP</div>
          </div>
        </div>
      </div>
    </div>
    <section class="copyright-section">
      <p>Copyright &copy; {{ company }}. 版权所有.</p>
      <a href="http://www.beian.gov.cn/">
        <p>{{ beianhao }}</p>
      </a>
    </section>
  </div>
</template>

<script>
export default {
  name: "Foots",
  data() {
    return {
      QRcode: "",
      downcode: "",
      company: "成都皖川家俱有限公司",
      address: "",
      weixin: "",
      beianhao: "",
    };
  },
  created() {
    this.getCode();
  },
  computed:{
	token(){
	  return this.$cookie.get('token')
	}
  },
  methods: {
    goAbute(url) {
      console.log("url", url);
      uni.navigateTo({
        url: url,
      });
    },
    getCode() {
      this.$http({
        url: this.$http.adornUrl3("api/index/pcapi/index_footer"),
        method: "post",
      }).then(({ data }) => {
		  //小程序二维码
        window.localStorage.setItem("QRcode", data.data.pc_miniapp);
        this.QRcode = data.data.pc_miniapp;
		//app下载地址
		window.localStorage.setItem("downcode", data.data.pc_appqrcode);
		this.downcode = data.data.pc_appqrcode;
		//公司名称
		this.company = data.data.pc_company;
		//公司地址
		this.address = data.data.com_address;
		//备案号
		this.beianhao = data.data.pc_beian;
		//微信号
		this.weixin = data.data.kefu_wechat;
      });
    },
    goTo(url){
		if(this.token){
			this.$router.push({
			  path:url,
			})
		}else{
			this.$router.push({
			  path:'/login',
			})
		}

      return false
    },
		goChat() {
			if(this.token) {
				this.$router.push({
					path: '/vueMchat'
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}
		},

  },
};
</script>
<style scoped = "scoped" lang="less">
.heads {
	background: #ffffff;
}
.big-center {
  width: 100%;
  height: 290px;
  line-height: 24px;
  color: #fff;
  font-size: 14px;
}

.center {

  display: flex;
  justify-content: center;
}

.cont {
  display: inline-block;
  font-size: 14px;
}

.left {
  text-align: left;
  padding-top: 36px;
}

.left img {
  width: 82%;
}

.conter {
  text-align: left;
  width: 30%;
  line-height: 40px;
}

.names {
  font-size: 20px;
}

.right {
	display: flex;
  padding-top: 58px;
  margin-left: 20px;
}

.right .xcx {
  text-align: center;
  margin-left: 70px;
  /* padding: 2% 10%; */
}

.right .xcx img {
  width: 96px;
}

.saoma {
  font-size: 14px;
  color: #333333;
  text-align: center;
}

.copyright-section {
  background: #fff;
}

.copyright-section p {
  color: #999999;
}

.copyright-section p span {
  color: #cccccc;
}

.copyright-section {
  padding: 30px 0;
  text-align: center;
  background: #000000;
}

.copyright-section p {
  margin-bottom: 0;
  font-size: 10px;
  text-transform: uppercase;
  color: #999;
  font-family: "Montserrat", sans-serif;
}

.copyright-section p span {
  color: #ccc;
}
.heads-top {
	display: flex;
    width: 1200px;
    margin: 0 auto;
    padding: 40px  20px 30px;
    box-sizing: border-box;
	border-bottom: 1px solid #E6E6E6;
	justify-content: space-between;
}

.box {
	display: flex;
	align-items: center;
}
.zpbz {
	margin-left: 10px;
}
.weixin1 {
	margin: 52px 0 22px 0;
}
ul {
  ol {

    font-size: 20px;
    margin-bottom: 14px;
    a {
      color:#333333;
      text-decoration: none;
    }
  }
  li {

    list-style: none;
    margin-top: 26px;
    a {
      color: #999999;
      text-decoration: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/foots.vue